export default __webpack_public_path__ + "device_spotlight_cam_plus.2dcd1fc8.png";